import { useEffect } from 'react';
import { Box } from '@mui/material';
import { NodeResizeControl, NodeResizer } from '@xyflow/react';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';
import { ComponentType } from 'src/types/SCADA/componentsTypes';
import { ResizeIcon } from 'src/assets/icons/SCADA/ResizeIcon';

type AssetWrapperProps = {
  id: string;
  selected: boolean;
  width?: number;
  height?: number;
  children: React.ReactNode;
  type?: ComponentType;
};

export const AssetWrapper = ({
  id,
  selected,
  width,
  height,
  children,
  type,
}: AssetWrapperProps) => {
  const { deleteNode, selectedNode } = useCustomDashboardContext();

  const isLockRatio = selectedNode?.data?.isLockRatio;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Delete' && selectedNode?.id === id) {
        deleteNode(id);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [id, selected, deleteNode, selectedNode?.id]);

  const displayResizeIcon = type !== ComponentType.TextLabel && type !== ComponentType.LiveTagLabel;

  return (
    <Box
      sx={{
        width,
        height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {selected && (
        <>
          <NodeResizer
            minWidth={5}
            minHeight={5}
            lineStyle={{ pointerEvents: 'none' }}
            handleStyle={{ pointerEvents: 'auto' }}
            keepAspectRatio={!!isLockRatio}
          />
          <NodeResizeControl
            keepAspectRatio={!!isLockRatio}
            style={{
              position: 'absolute',
              right: 1,
              bottom: 4,
              background: 'transparent',
              transform: 'translate(-3px, -3px)',
              border: 'none',
              cursor: 'nwse-resize',
            }}
            minWidth={5}
            minHeight={5}
          >
            {displayResizeIcon && <ResizeIcon />}
          </NodeResizeControl>
        </>
      )}

      {children}
    </Box>
  );
};
